import React, { useMemo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import moment from 'moment';
import classNames from 'classnames';
import { getTournamentChats } from '../../../../../../../../store/selectors';
import { groupByAdjacent } from '../helpers/array';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const emptyChat = [];

const renderMessage = message => {
  let messageClasses = classNames('tournaments__chat__message', { 'tournaments__chat__message--self': message.self });

  return (
    <React.Fragment>
      {!message.self && <div className="tournaments__chat__message-sender">{message.username}</div>}
      <div className={messageClasses} key={message.on}>
        <div className="tournaments__chat__message-text">{message.text}</div>
        <div className="tournaments__chat__message-time">{moment(message.on).format('HH:mm')}</div>
      </div>
    </React.Fragment>
  );
}

const renderMessageGroup = group => {
  const firstElem = group[0];
  const newGroup = group.map((item, idx) => {
    let username;
    idx > 0 
        ? username = group[idx]['username'] === group[idx - 1]['username'] ? '' : username =  group[idx]['username'] 
        : username = group[0]['username']
    return {...item, username}
  })
  return (
    <div className="tournaments__chat__group" id="messagesContainer" key={firstElem.on}>
      {newGroup.map(renderMessage)}
    </div>
  );
}

const TournamentChat = ({ tournamentId, dark, onClose }) => {
  const { t } = useTranslation(); 
  const chats = useSelector(getTournamentChats);
  const messages = tournamentId in chats ? chats[tournamentId] : emptyChat;
  const groupedMessages = useMemo(() => groupByAdjacent(messages, (a, b) => a.email === b.email), [messages]);

  const classes = classNames('tournaments__chat', { 'tournaments__chat--dark': dark });

  const scrollToBottom = () => {
    let el = document.getElementById('messagesContainer')
    if(el) 
      el.scrollIntoView({ behavior: "smooth", block: 'end' })
  }

  useEffect(()=> {
    scrollToBottom()
  },[groupedMessages])

  return (
    <div className={classes}>
      <header className="tournaments__chat__header">
        <div className="tournaments__chat__title">{t('tournaments.liveChat')}</div>
        <FontAwesomeIcon icon={faTimes} onClick={onClose}/>
      </header>
      <Scrollbars className="tournaments__chat__body" universal>
        {groupedMessages.map(renderMessageGroup)}
      </Scrollbars>
    </div>
  );
}

export default TournamentChat;